// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switchValueBlock__cR8wM {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  min-width: 75px;
  cursor: pointer;
}

.arrowsIcon__saQ1j {
  width: 18px;
  height: 18px;
}
.arrowsIcon__saQ1j path {
  fill: var(--header-icon-secondary);
}

.switchPopover__UslnL {
  width: 100px !important;
  padding: 0 !important;
  background: var(--context-menu-surface) !important;
  text-align: left !important;
  opacity: 1 !important;
  border-radius: 0;
  box-shadow: var(--modal-box-shadow);
}

.switchDisabled__lDHbi {
  pointer-events: none;
}

.switchPopoverItem__BsKvc {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  text-transform: uppercase;
  color: var(--context-menu-text);
  font-size: 10px;
  border: 1px solid var(--context-menu-stroke);
  border-bottom: unset;
}
.switchPopoverItem__BsKvc:hover {
  font-weight: 500;
  background-color: inherit;
}
.switchPopoverItem__BsKvc:last-child {
  border-bottom: 1px solid var(--context-menu-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Header/components/GroupFacilitySwitcher/style.module.scss"],"names":[],"mappings":"AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,YAAA;AA5EF;AA8EE;EACE,kCAAA;AA5EJ;;AAgFA;EAEE,uBAAA;EACA,qBAAA;EACA,kDAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mCAAA;AA9EF;;AAiFA;EACE,oBAAA;AA9EF;;AAiFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,4CAAA;EACA,oBAAA;AA9EF;AAgFE;EACE,gBAAA;EACA,yBAAA;AA9EJ;AAiFE;EACE,mDAAA;AA/EJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.switcherBlock {\n}\n\n.switchValueBlock {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 13px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  min-width: 75px;\n  cursor: pointer;\n}\n\n.arrowsIcon {\n  width: 18px;\n  height: 18px;\n\n  path {\n    fill: var(--header-icon-secondary);\n  }\n}\n\n.switchPopover {\n  // importants below to overwrite react-tooltip styles\n  width: 100px !important;\n  padding: 0 !important;\n  background: var(--context-menu-surface) !important;\n  text-align: left !important;\n  opacity: 1 !important;\n  border-radius: 0;\n  box-shadow: var(--modal-box-shadow);\n}\n\n.switchDisabled {\n  pointer-events: none;\n}\n\n.switchPopoverItem {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  text-transform: uppercase;\n  color: var(--context-menu-text);\n  font-size: 10px;\n  border: 1px solid var(--context-menu-stroke);\n  border-bottom: unset;\n\n  &:hover {\n    font-weight: 500;\n    background-color: inherit;\n  }\n\n  &:last-child {\n    border-bottom: 1px solid var(--context-menu-stroke);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchValueBlock": `switchValueBlock__cR8wM`,
	"arrowsIcon": `arrowsIcon__saQ1j`,
	"switchPopover": `switchPopover__UslnL`,
	"switchDisabled": `switchDisabled__lDHbi`,
	"switchPopoverItem": `switchPopoverItem__BsKvc`
};
module.exports = ___CSS_LOADER_EXPORT___;
